import React, { useEffect, useState } from "react"
import Calendar from "../../Calendar/Calendar";
import dayjs from "dayjs";

const SpecificDates = ({ handleChangeValue, selectedValue }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleDateChange = (key, value) => {
    const newDate = dayjs(value);

    if (key === "startDate") {
      setStartDate(newDate);
    } else {
      setEndDate(newDate);
    }

    handleChangeValue({
      startDate: key === "startDate" ? newDate : startDate,
      endDate: key === "endDate" ? newDate : endDate,
    });
  };

  useEffect(() => {
    if (typeof selectedValue === 'object') {
      setStartDate(selectedValue?.startDate)
      setEndDate(selectedValue?.endDate)
    }
  }, [])


  return (
    <div className='flex flex-row items-center'>
      <Calendar
        withLabel={false}
        width="w-full"
        placeholder="Start Date"
        value={startDate}
        onChange={(val) => handleDateChange("startDate", val)}
        isRequired={true}
        parentClassName='min-w-[170px] mr-4 mt-2'
        height='50px'
      />
      <Calendar
        withLabel={false}
        parentClassName='min-w-[170px] mr-4 mt-2'
        height='50px'
        width="w-full"
        placeholder="End Date"
        value={endDate}
        onChange={(val) => handleDateChange("endDate", val)}
        isRequired={true}
      />
    </div>
  );
};

export default SpecificDates;